<template>
	<div>
		<div class="floor-box w">
			<div class="d-flex floor-title justify-content-between align-items-center">
				<h4 v-text="param.title"></h4>
				<ul class="d-flex">
					<template v-for="(item,index) in param.list">
						<li v-text="item.cat_name" :class="{'active': index == param.active_index}" @mousemove="floorTab(index)"></li>
					</template>
				</ul>
			</div>
			<div class="floor-content d-flex">
				<div class="advert">
					<template v-if="param.page_url.indexOf('http') != -1">
						<a :href="param.page_url" target="_blank"><img class="img-default" :src="param.pic_url" alt /></a>
					</template>
					<template v-else>
						<router-link :to="param.page_url"><img class="img-default" :src="param.pic_url" alt /></router-link>
					</template>
				</div>
				<template v-for="(item,index) in param.list">
					<ul class="list d-flex flex-wrap" v-show="index == param.active_index">
						<li class="item" v-for="(goods_item,goods_index) in param.list[index].goods_list" :key="goods_index">
							<router-link :to="{path:'/pages/goods/goods',query:{id:goods_item.id}}" target="_blank">
								<img class="img-default item-img" :src="goods_item.pic_url" alt :onerror="errorImg" />
								<div class="name show-two-lines" v-text="goods_item.name"></div>
								<div class="pic" v-text="'¥'+goods_item.price"></div>
							</router-link>
						</li>
					</ul>
				</template>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		props: {
			param: {
				type: Object,
				default () {
					return {};
				},
			}
		},
		data() {
			return {
				errorImg: 'this.src="' + require('../../../assets/images/lodingsb.svg') + '"' //图片加载失败
			};
		},
		methods: {
			floorTab(index) {
				this.param.active_index = index;
			}
		}
	};
</script>

<style lang="scss" scoped>
	.floor-box{
		margin-top: 20px;
	}
	.floor-title{
		padding: 17px 0 7px;
		h4{
			font-weight: 500;
			font-size: 28px;
			color: #333333;
			line-height: 28px;
		}
		ul{
			li{
				font-size: 14px;
				font-weight: 400;
				color: #333333;
				line-height: 28px;
				margin-left: 24px;
				transition: color 0.3s;
				cursor: pointer;
			}
			li:hover,li.active{
				color: #FF0E25;
				font-weight: 500;
			}
			li:first-child{
				margin-left: 0;
			}
		}
	}
	.floor-content{
		.advert{
			margin-top: 10px;
			width: 250px;
			height: 590px;
			background: #CCCCCC;
			cursor: pointer;
			overflow: hidden;
			img{
				transition: 0.5s;
				-moz-transition: 0.5s;
				-webkit-transition: 0.5s;
				-o-transition: 0.5s;
			}
			img:hover{
				transform: scale(1.1);
			}
		}
		.list {
			width: 940px;
			.item {
				cursor: pointer;
				width: 225px;
				height: 290px;
				background-color: #fff;
				margin: 10px 0 0 10px;
				padding: 15px;
				box-sizing: border-box;
				transition: .5s;
				-moz-transition: .5s;
				-webkit-transition: .5s;
				-o-transition: .5s;

				&:hover {
					box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
				}

				.item-img {
					width: 195px;
					height: 195px;
				}

				.pic {
					font-size: 16px;
					color: #ff4300;
					margin-top: 4px;
					text-align: center;
				}

				.name {
					font-size: 12px;
					font-weight: 400;
					color: #666666;
					line-height: 18px;
					height: 36px;
					margin-top: 10px;
					text-align: center;
				}

				.label {
					margin-top: 8px;
					max-height: 44px;
					overflow: hidden;
					span {
						min-width: 32px;
						padding: 0px 4px;
						border-radius: 3px;
						border: 1px solid #ff0e25;
						box-sizing: border-box;
						display: inline-block;
						color: #ff0e25;
						margin: 0 4px 4px 0;
					}
				}
			}
		}
	}
</style>
